import * as CryptoJS from "crypto-js";
export var encryptAccode = function (Accode) {
    var key = CryptoJS.enc.Utf8.parse("7061737323313233");
    var iv = CryptoJS.enc.Utf8.parse("7061737323313233");
    var encrypted = CryptoJS.AES.encrypt(CryptoJS.enc.Utf8.parse(Accode), key, {
        keySize: 128 / 8,
        iv: iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7,
    });
    return encodeURIComponent(encrypted.toString());
};
export var encryptedAccodeVer1 = function (Accode) {
    var key = CryptoJS.enc.Utf8.parse("70617373233132337061737323313233");
    var iv = CryptoJS.enc.Utf8.parse("70617373233132337061737323313233");
    var encrypted = CryptoJS.AES.encrypt(CryptoJS.enc.Utf8.parse(Accode), key, {
        keySize: 32,
        iv: iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7,
    });
    //console.log("encrypted",encodeURIComponent(encodeURIComponent(encodeURIComponent(encrypted.toString()))));
    //console.log("encrypted",encodeURIComponent(encodeURIComponent(encrypted.toString())));
    return encodeURIComponent(encodeURIComponent(encrypted.toString()));
};
export function DecryptAccode(Accode) {
    var key = CryptoJS.enc.Utf8.parse("70617373233132337061737323313233");
    var iv = CryptoJS.enc.Utf8.parse("70617373233132337061737323313233");
    var decrypted = CryptoJS.AES.decrypt(decodeURIComponent(decodeURIComponent(Accode)), key, {
        keySize: 32,
        iv: iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7,
    });
    return decrypted.toString(CryptoJS.enc.Utf8);
}
export function genericEncrypt(keyString, ivString, needToEncrypt, keySize) {
    var key = CryptoJS.enc.Utf8.parse(keyString);
    var iv = CryptoJS.enc.Utf8.parse(ivString);
    var encrypted = CryptoJS.AES.encrypt(CryptoJS.enc.Utf8.parse(needToEncrypt), key, {
        keySize: keySize,
        iv: iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7,
    });
    return encrypted.ciphertext.toString();
}
export function genericDecrypt(keyString, ivString, needToDecrypt, keySize) {
    var key = CryptoJS.enc.Utf8.parse(keyString);
    var iv = CryptoJS.enc.Utf8.parse(ivString);
    //console.log("decodeURIComponent(decodeURIComponent(needToDecrypt)",decodeURIComponent(decodeURIComponent(needToDecrypt)));
    var decrypted = CryptoJS.AES.decrypt(decodeURIComponent(decodeURIComponent(needToDecrypt)), key, {
        keySize: 32,
        iv: iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7,
    });
    //console.log("decrypted",decrypted.toString(CryptoJS.enc.Utf8));
    return decrypted.toString(CryptoJS.enc.Utf8);
}
export function generateHashForHmacSHA256(key, message) {
    return CryptoJS.HmacSHA256(message, key).toString(CryptoJS.enc.Hex);
}
export var generateRandomString = function () {
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
        var r = (Math.random() * 16) | 0, v = c == "x" ? r : (r & 0x3) | 0x8;
        return v.toString(16);
    });
};
